import { ServiceList } from "@/components/app/ServiceList";

export const AlertsView = ({ summary }) => {
  if (!summary) return null;
  return (
    <div className="space-y-10" data-testid="alerts-view">
      <ServiceList title="Vencidos (agendamento não realizado)" items={summary.overdue} empty="Nenhum serviço vencido." testid="overdue-list" />
      <ServiceList title={`Vencem nos próximos ${summary.alert_days} dias`} items={summary.due_soon} empty="Nenhum vencimento próximo." testid="due-soon-list" />
    </div>
  );
};
